import {AxiosProgressEvent} from 'axios';

import {RemotePostUploadFilePreview} from 'data/usecases/private/refund/request-preview';
import {PostUploadFilePreview} from 'domain/usecases/private/refund/request-preview';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePostUploadFilePreview = (
	onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
): PostUploadFilePreview =>
	new RemotePostUploadFilePreview(
		makeBFFApiUrl(RefundFlowEndPoints.requestPreviewAttachment),
		makeAuthorizeHttpClientDecorator(),
		onUploadProgress,
	);
